import { render, staticRenderFns } from "./CollapsedPanel.vue?vue&type=template&id=f46bcc08&scoped=true&"
import script from "./CollapsedPanel.vue?vue&type=script&lang=js&"
export * from "./CollapsedPanel.vue?vue&type=script&lang=js&"
import style0 from "./CollapsedPanel.vue?vue&type=style&index=0&id=f46bcc08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46bcc08",
  null
  
)

export default component.exports